import React, { useMemo } from "react";

import styles from "./AccordionSection.module.scss";
import SectionWrapper from "components/elements/SectionWrapper";

const AccordionSection = (props) => {
    const { alignment, data } = props;

    const randomId = useMemo(
        () => `.accordion-${Math.random().toString(36).substring(2, 11)}`,
        []
      );

    return (
        <div className={`text-${alignment ? alignment : "left"}`}>
            <SectionWrapper 
                className={`${styles.AccordionSection}`} 
                fluid={false} 
                {...props}
            >

                <div className={`row ${alignment && 'justify-content-' + alignment}`}>
                    <div className="col">
                        <div className={`accordion accordion-flush ${randomId}`}>
                            {data && data.map((item, index) => (
                                <div className="accordion-item" key={index}>
                                    <h2 className="accordion-header" id={`heading${index}`}>
                                        <button 
                                            className={`accordion-button ${index > 0 && "collapsed"}`}
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target={`#collapse${index}`}
                                            aria-expanded="false"
                                            aria-controls={`collapse${index}`}
                                        >
                                            {item.title}
                                        </button>
                                    </h2>
                                    <div
                                        id={`collapse${index}`}
                                        className={`accordion-collapse collapse ${index === 0 && "show"}`}
                                        aria-labelledby={`heading${index}`}
                                        data-bs-parent={randomId}
                                    >
                                        <div className="accordion-body">{item.desc}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            
            </SectionWrapper>
        </div>
    );
};

export default AccordionSection;